<template>
  <div v-if="config?.HMS?.open" @click.stop.prevent="config.HMS.open = false"
    class="fixed w-full h-full top-0 right-0 bg-g0/90 flex justify-center items-center z-[999] cursor-default">
    <div class="py-9 px-8 bg-g1 text-white max-w-[600px] w-[90vw] relative" @click.stop.prevent="">

      <svg class="absolute top-[10px] right-[10px] cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="15"
        viewBox="0 0 10.561 10.561" @click.stop.prevent="config.HMS.open = false">
        <g transform="translate(-815.793 -21.793)">
          <line y1="9.147" x2="9.147" transform="translate(816.5 22.5)" fill="none" stroke="#fff" stroke-width="2" />
          <line y1="9.147" x2="9.147" transform="translate(825.647 22.5) rotate(90)" fill="none" stroke="#fff"
            stroke-width="2" />
        </g>
      </svg>

      <h2 class="mb-4 text-3xl">{{ $e("Message HMS") }} :</h2>

      <div
        class="flex flex-col align-middle justify-between p-2 mb-2 max-h-[70vh] overflow-y-scroll showScroolBar pr-3">
        <template v-for="type in ['dock', 'drone']" :key="type">
          <template v-if="config.HMS?.errorHMS[type]?.length > 0">
            <h3 class="mb-3">{{ $e(type).toUpperCase() }}</h3>

            <template v-for="(hms, index) in config.HMS.errorHMS[type]" :key="index">
              <div class="flex flex-col mb-4 pb-4 border-b border-g2">
                <div class="flex justify-between">
                  <small class="text-xs text-mono text-g3">
                    {{ hms.code }} - {{ dateShow(hms.ts) }}
                  </small>

                  <div class="text-xs text-mono text-g3">
                    {{ enVol(hms.insky) }} | {{ $e("imminent") }}. {{ hms.imminent }} | {{ $e("niveau") }}. {{ hms.level }}
                  </div>
                </div>

                <p class="text-base">
                  {{ $e(hms.error) }}
                </p>
              </div>
            </template>
          </template>
        </template>
      </div>

    </div>
  </div>
</template>
<script>

export default {
  name: "HMS",
  props: {
    config: Object,
    classTpl: Object
  },
  components: {
  },

  methods: {
    dateShow(date) {
      return new Date(date).toLocaleString();
    },

    enVol(insky) {
      return insky ? 'En vol' : 'Au sol';
    }
  },
};
</script>
